<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <span class="mr-2 text-h6">
          {{ $t('header') }}
        </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.delimiter"
          :label="$t('delimiter')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col v-if="propProfile.virtualPrefix" cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.virtualPrefix"
          :label="$t('virtualPrefix')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col v-else cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.headerPrefix"
          :label="$t('headerPrefix')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.ticketNumberIndex"
          :label="$t('ticketNumberIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.settingIndex"
          :label="$t('settingIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.tractIndex"
          :label="$t('tractIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.destinationIndex"
          :label="$t('destinationIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.contractAccountIndex"
          :label="$t('contractAccountIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.productIndex"
          :label="$t('productIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.weighedOutAtIndex"
          :label="$t('weighedOutAtIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.inWeightIndex"
          :label="$t('inWeightIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.outWeightIndex"
          :label="$t('outWeightIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.netWeightIndex"
          :label="$t('netWeightIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.trailerIdentifierIndex"
          :label="$t('trailerIdentifierIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="mr-2 text-h6">
          {{ $t('log') }}
        </span>
      </v-col>
      <v-col v-if="!propProfile.virtualPrefix" cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.logPrefix"
          :label="$t('logPrefix')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.speciesIndex"
          :label="$t('speciesIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.buttLogIndex"
          :label="$t('buttLogIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentOne') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGradeIndex"
          :label="$t('segmentOneGradeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneEndUseSortIndex"
          :label="$t('segmentOneEndUseSortIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneLengthIndex"
          :label="$t('segmentOneLengthIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDiameterIndex"
          :label="$t('segmentOneDiameterIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGrossVolumeIndex"
          :label="$t('segmentOneGrossVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneNetVolumeIndex"
          :label="$t('segmentOneNetVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDefectVolumeIndex"
          :label="$t('segmentOneDefectVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentTwo') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGradeIndex"
          :label="$t('segmentTwoGradeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoEndUseSortIndex"
          :label="$t('segmentTwoEndUseSortIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoLengthIndex"
          :label="$t('segmentTwoLengthIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDiameterIndex"
          :label="$t('segmentTwoDiameterIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGrossVolumeIndex"
          :label="$t('segmentTwoGrossVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoNetVolumeIndex"
          :label="$t('segmentTwoNetVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDefectVolumeIndex"
          :label="$t('segmentTwoDefectVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentThree') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeLengthIndex"
          :label="$t('segmentThreeLengthIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeDiameterIndex"
          :label="$t('segmentThreeDiameterIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeGrossVolumeIndex"
          :label="$t('segmentThreeGrossVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeNetVolumeIndex"
          :label="$t('segmentThreeNetVolumeIndex')"
          outlined
          readonly
          color="black"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ScaleSheetImportDelimitedProfileDetail',

  props: {
    propProfile: {
      type: Object,
      required: true
    }
  }
}
</script>
